// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const SSHGenerateButtonContainer = styled.div`
    display: flex;
    flex-direction: column-reverse;
`;